// header nav
import HeaderNav from "./components/navigation/HeaderNav.vue";
window.vueApp.component("header-nav", HeaderNav);

// cookie consent
import CookieConsent from "./components/utilities/CookieConsent";
window.vueApp.component("cookie-consent", CookieConsent);

// cookie consent footer nav
import CookieConsentFooterNav from "./components/utilities/CookieConsentFooterNav";
window.vueApp.component("cookie-consent-footer-nav", CookieConsentFooterNav);

// contact page
import ContactForm from "./components/pageContact/ContactForm.vue";
window.vueApp.component("contact-form", ContactForm);

// profile page
import ProfilePageContactVendor from "./components/profilePage/ProfilePageContactVendor.vue";
window.vueApp.component("profile-page-contact-vendor", ProfilePageContactVendor);

// register page
import PageRegister from "./components/pageRegister/PageRegister.vue";
window.vueApp.component("page-register", PageRegister);

// offer request list view page
import PageOfferRequestListView from "./components/pageOfferRequestListView/PageOfferRequestListView.vue";
window.vueApp.component("page-offer-request-list-view", PageOfferRequestListView);

// offer search page
import OfferSearchForm from "./components/pageOfferSearch/OfferSearchForm.vue";
window.vueApp.component("offer-search-form", OfferSearchForm);

// offer details page
import PageOfferDetails from "./components/pageOfferDetails/PageOfferDetails.vue";
window.vueApp.component("page-offer-details", PageOfferDetails);

// browser detection
import BadgeRounded from "./components/badges/BadgeRounded.vue";
window.vueApp.component("badge-rounded", BadgeRounded);

// browser detection
import BrowserDetectionFormFields from "./components/browserDetection/BrowserDetectionFormFields";
window.vueApp.component("browser-detection-form-fields", BrowserDetectionFormFields);

// browser detection
import AdvertisingWrapper from "./components/advertising/AdvertisingWrapper.vue";
window.vueApp.component("advertising-wrapper", AdvertisingWrapper);

// -- Global UTILITIES --

import OfferGrid from "./components/offerGrid/OfferGrid.vue";
window.vueApp.component("offer-grid", OfferGrid);

import NewsletterSignupForm from "./components/utilities/NewsletterSignupForm.vue";
window.vueApp.component("newsletter-signup-form", NewsletterSignupForm);

import GoogleMaps from "./components/utilities/GoogleMaps.vue";
window.vueApp.component("google-maps", GoogleMaps);

import NavSearchForm from "./components/utilities/NavSearchForm.vue";
window.vueApp.component("nav-search-form", NavSearchForm);

import ModalMasterGuest from "./components/modal/ModalMasterGuest.vue";
window.vueApp.component("modal-master-guest", ModalMasterGuest);

import SupportWidget from "./components/supportWidget/SupportWidget.vue";
window.vueApp.component("support-widget", SupportWidget);

import PlainButton from "./components/buttons/PlainButton";
window.vueApp.component("plain-button", PlainButton);

import InputText from "./components/inputs/InputText";
window.vueApp.component("input-text", InputText);

import InputTextarea from "./components/inputs/InputTextarea";
window.vueApp.component("input-textarea", InputTextarea);

import InputSelect from "./components/inputs/InputSelect";
window.vueApp.component("input-select", InputSelect);
